import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23c3701f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-cards"
}
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "list-inner" }
const _hoisted_4 = { class: "filter-wrapper" }
const _hoisted_5 = { class: "table-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_FilterPanel = _resolveComponent("FilterPanel")!
  const _component_PoolTable = _resolveComponent("PoolTable")!
  const _component_WebSocket = _resolveComponent("WebSocket")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["stockpool", _ctx.theme])
  }, [
    (_ctx.hasProductData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productData, (product) => {
            return (_openBlock(), _createBlock(_component_ProductCard, _mergeProps({
              key: product.courseNo
            }, _ctx.getProductCardProps(product), { theme: _ctx.theme }), null, 16, ["theme"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FilterPanel, _mergeProps(_ctx.filterPanelProps, {
            onFilterChange: _ctx.handleFilterChange,
            onDateChange: _ctx.handleDateChange,
            onOptionalChange: _ctx.handleOptionalChange,
            onSignalTypeChange: _ctx.handleSignalTypeChange,
            onRefresh: _ctx.handleRefresh,
            onStockSelect: _ctx.handleStockSelect,
            onStockDblclick: _ctx.handleStockDblClick,
            onMainTabChange: _ctx.handleMainTabChange
          }), null, 16, ["onFilterChange", "onDateChange", "onOptionalChange", "onSignalTypeChange", "onRefresh", "onStockSelect", "onStockDblclick", "onMainTabChange"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_PoolTable, _mergeProps({ ref: "poolTableRef" }, _ctx.poolTableProps, {
            onChange: _ctx.handleTableChange,
            onLoadMore: _ctx.handleLoadMore
          }), null, 16, ["onChange", "onLoadMore"])
        ])
      ])
    ]),
    _createVNode(_component_WebSocket, {
      sourceData: _ctx.poolList,
      listKey: _ctx.currentWsListKey,
      onMessage: _ctx.websocketonmessage
    }, null, 8, ["sourceData", "listKey", "onMessage"])
  ], 2))
}